'use strict';

function crossfilter_null() {
  return null;
}

module.exports = crossfilter_null;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter2/src/null.js
// module id = 887
// module chunks = 0